import { render, staticRenderFns } from "./ViewAgentTaskNotes.vue?vue&type=template&id=3582c174&scoped=true"
import script from "./ViewAgentTaskNotes.vue?vue&type=script&lang=js"
export * from "./ViewAgentTaskNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3582c174",
  null
  
)

export default component.exports